import alta_alella from "../images/alta-alella-vineyards.jpg";
import mas_salagros_bar from "../images/bar.jpg";
import mas_salagros_baths from "../images/baths.jpg";
import veintidos_arroba from "../images/distrito22arr.jpg";
import mas_salagros_junior from "../images/juniorsuite.jpg";
import mas_salagros_panoramic from "../images/mas-salagros-panoramic.jpg";
import mas_salagros from "../images/mas-salagros.jpg";
import alta_alella_pica_pica from "../images/pica-pica.jpg";
import alta_alella_vinyes from "../images/vinyes.png";
import bcn_smart_rambles from "../images/smartrambles.png";
import valkiria1 from "../images/valkiria1.jpg";
import valkiria2 from "../images/valkiria2.jpg";
import bike_lanes from "../images/bikelanes.jpg";
import mirabe from "../images/mirabe.jpg";
import trabuc_day from "../images/Trabuc.jpg";
import trabuc_night from "../images/trabuc-night.jpg";

const tileData = [
  {
    img: mas_salagros_bar,
    title: "Mas Salagros bar area",
  },
  {
    img: mas_salagros_baths,
    title: "Some of the spa facilities available",
  },
  {
    img: mas_salagros_junior,
    title: "Hotels Junior Suites",
  },
  {
    img: mas_salagros_panoramic,
    title: "The resort",
  },
  {
    img: mas_salagros,
    title: "Resort surrounded by nature",
  },
  {
    img: alta_alella_vinyes,
    title: "Beautiful vineyards",
  },
  {
    img: trabuc_day,
    title: "Lunch at Wine cellar",
  },
  {
    img: trabuc_night,
    title: "Dinner property by night",
  },
  {
    img: veintidos_arroba,
    title: "Hub for Digital Entrepreneurs",
  },
  {
    img: bcn_smart_rambles,
    title: "IoT driven city",
  },
  {
    img: valkiria1,
    title: "Digital workshop hapening here",
  },
  {
    img: valkiria2,
    title: "Workshop facilities",
  },
  {
    img: mirabe,
    title: "Panoramic restaurant en-route to Airport",
  },

  {
    img: bike_lanes,
    title: "310Km of bike lanes ",
  },
];

export default tileData;
